import { useTranslation } from "react-i18next";
import {
  DatePicker as MuiDatePicker,
  LocalizationProvider as MuiLocalizationProvider,
} from "@mui/x-date-pickers-pro";
import { AdapterDateFns as MuiAdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { getIsValidDate } from "app/shared/utils";

export const ComponentStartDateField = ({
  value,
  expirationDate,
  onChange,
  required = false,
  size = "medium",
  ...passedParams
}) => {
  const { t } = useTranslation();

  return (
    <MuiLocalizationProvider dateAdapter={MuiAdapterDateFns}>
      <MuiDatePicker
        {...passedParams}
        required={required}
        value={getIsValidDate(value)}
        onChange={(val) => {
          onChange(val);
        }}
        maxDate={(expirationDate && new Date(expirationDate)) || undefined}
        maxDateMessage={t(
          `Commitments.commitmentComponents.create.form.fields.startDate.validation.maxDateMessage`
        )}
        format="MM/dd/yyyy"
        slotProps={{
          textField: {
            required,
            size,
            variant: "outlined",
            fullWidth: true,
            slotProps: { htmlInput: { autoComplete: "off" } },
          },
        }}
      />
    </MuiLocalizationProvider>
  );
};
